export function formatSwissPhoneNumber(phone = '') {
  let stripped = phone.replace(/\s+/g, '').replace(/[^\d+]/g, '');
  if (stripped.startsWith('+41')) {
    stripped = stripped.slice(3);
  } else if (stripped.startsWith('0041')) {
    stripped = stripped.slice(4);
  } else {
    return phone;
  }
  if (stripped.startsWith('0')) {
    stripped = stripped.slice(1);
  }
  if (/^\d{9}$/.test(stripped)) {
    const chunk1 = stripped.slice(0, 2);
    const chunk2 = stripped.slice(2, 5);
    const chunk3 = stripped.slice(5, 7);
    const chunk4 = stripped.slice(7, 9);
    return `+41 ${chunk1} ${chunk2} ${chunk3} ${chunk4}`;
  }
  return phone;
}